import {
  Validation,
  ValidationResult,
} from "../../common/validation/constants";
import { useMemo } from "react";
import { useAppSelector } from "../../app";
import { selectActiveDocumentLanguage } from "../../document";
import { shouldBeValidated } from "../utils/validationUtils";

const defaultValidation = {
  show: false,
  type: null,
};

const useValidation = (
  value: string,
  validationId: string,
  validations: Array<Validation>,
) => {
  const docLanguage = useAppSelector(selectActiveDocumentLanguage);
  const blurredEntities = useAppSelector(
    (state) => state.appReducer.blurredEntities,
  );

  // Purely derived from value/validations/language/blur state, so it is
  // computed during render instead of being pushed into state from an effect.
  // As before, the last failing validation wins and "no failures" falls back
  // to defaultValidation.
  const validationResult = useMemo<ValidationResult>(() => {
    let result: ValidationResult = defaultValidation;

    validations.forEach((validation) => {
      const { requiresValue, awaitBlur, validate, type, message, icon } =
        validation;

      if (!shouldBeValidated(value, requiresValue)) {
        return;
      }

      if (!validate(value, docLanguage)) {
        result = {
          show: awaitBlur ? blurredEntities.includes(validationId) : true,
          type,
          message,
          icon,
        };
      }
    });

    return result;
  }, [value, validations, validationId, docLanguage, blurredEntities]);

  return validationResult;
};

export default useValidation;
